var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStars = function SvgIconStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-stars_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-stars_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-stars_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.955 2.33 1.545-.58.58-1.545a.316.316 0 0 1 .59 0l.58 1.545 1.545.58a.316.316 0 0 1 0 .59l-1.545.58-.58 1.545a.316.316 0 0 1-.59 0L10.5 3.5l-1.545-.58c-.148-.046-.205-.164-.205-.295 0-.132.057-.25.205-.296ZM7.05 5.12l3.117 1.441a.437.437 0 0 1 0 .796L7.05 8.8l-1.44 3.117a.437.437 0 0 1-.796 0L3.37 8.8.254 7.36a.437.437 0 0 1 0-.796L3.371 5.12l1.442-3.117a.438.438 0 0 1 .795 0L7.05 5.121Zm4.03 3.834c.047-.148.165-.205.296-.205.131 0 .249.057.295.205l.58 1.545 1.545.58a.316.316 0 0 1 0 .59l-1.545.58-.58 1.545a.316.316 0 0 1-.59 0l-.58-1.545-1.545-.58c-.148-.046-.205-.164-.205-.295 0-.131.057-.249.205-.295l1.545-.58.58-1.545Z",
    fill: "#FC0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-stars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-stars_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-stars_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIconStars;